import { getStoredSessionToken } from '../../../app/services/session.service';

const API_BASE_URL = (process.env.REACT_APP_CLIENTS_API_BASE_URL || '').replace(/\/$/, '');
const API_PATH = '/api/clients/custom-fields';

function authHeaders(extraHeaders = {}) {
  const token = getStoredSessionToken();
  return token ? { ...extraHeaders, Authorization: `Bearer ${token}` } : extraHeaders;
}

function readPayload(response) {
  return response.json().catch(() => null);
}

function result(ok, data = null, error = null, message = '') {
  return { ok, data, error, message };
}

export async function listClientCustomFields() {
  const response = await fetch(`${API_BASE_URL}${API_PATH}`, { headers: authHeaders() });
  const payload = await readPayload(response);
  if (!response.ok) throw new Error(payload?.message || 'Campi personalizzati non disponibili.');
  return Array.isArray(payload) ? payload : [];
}

export async function createClientCustomField(definition) {
  const response = await fetch(`${API_BASE_URL}${API_PATH}`, {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(definition),
  });
  const payload = await readPayload(response);
  return response.ok
    ? result(true, payload)
    : result(false, null, 'CUSTOM_FIELD_CREATE_FAILED', payload?.message || 'Impossibile salvare il campo.');
}

export async function archiveClientCustomField(id) {
  const response = await fetch(`${API_BASE_URL}${API_PATH}/${encodeURIComponent(id)}`, {
    method: 'DELETE',
    headers: authHeaders(),
  });
  const payload = await readPayload(response);
  return response.ok
    ? result(true)
    : result(false, null, 'CUSTOM_FIELD_ARCHIVE_FAILED', payload?.message || 'Impossibile archiviare il campo.');
}
